export const SAVE = 'stepOverseasMedical.SAVE';
export const VALUE_CHANGED = 'stepOverseasMedical.VALUE_CHANGED';
export const LOAD = 'stepOverseasMedical.VALUE_LOAD';
export const NEXT = 'stepOverseasMedical.NEXT';
export const RESET = 'stepOverseasMedical.RESET';
export const RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES = 'stepOverseasMedical.RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES';
export const RESET_ACCIDENTAL_DEATH = 'stepOverseasMedical.RESET_ACCIDENTAL_DEATH';
export const RESET_LOSS_OF_INCOME = 'stepOverseasMedical.RESET_LOSS_OF_INCOME';
export const RESET_CONTACT_EMERGENCY_ASSISTANCE = 'stepOverseasMedical.RESET_CONTACT_EMERGENCY_ASSISTANCE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/constants.js